/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, toRefs, computed } from '@vue/composition-api';
import { AddIcon, BrowseIcon, DeleteIcon, ErrorCircleFilledIcon } from 'tdesign-icons-vue';
import { Loading } from '../../loading/index.js';
import { useGlobalIcon } from '../../hooks/useGlobalIcon.js';
import { ImageViewer } from '../../image-viewer/index.js';
import { commonProps } from '../constants.js';
import { abridgeName } from '../../_common/js/upload/utils.js';
import { renderTNodeJSX } from '../../utils/render-tnode.js';
import { Link } from '../../link/index.js';
import { Image } from '../../image/index.js';
import '../../loading/directive.js';
import 'lodash/isObject';
import 'lodash/mapKeys';
import 'lodash/isEqual';
import '../../loading/plugin.js';
import 'vue';
import '../../loading/loading.js';
import '../../loading/icon/gradient.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/isString';
import 'lodash/isNull';
import 'lodash/isUndefined';
import 'lodash/isNumber';
import 'lodash/isArray';
import '../../config-provider/config-receiver.js';
import 'lodash/mergeWith';
import '../../config-provider/context.js';
import 'lodash/merge';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../../_chunks/dep-9849f16c.js';
import '../../config-provider/type.js';
import '../../utils/mixins.js';
import '../../utils/dom.js';
import 'raf';
import '../../utils/easing.js';
import '../../utils/transfer-dom.js';
import '../../loading/props.js';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../../config.js';
import '../../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../../loading/type.js';
import '../../hooks/useConfig.js';
import '../../config-provider/useConfig.js';
import '../../image-viewer/image-viewer.js';
import '../../image-viewer/props.js';
import '../../image-viewer/base/Container.js';
import '../../image-viewer/base/ImageModalIcon.js';
import '../../hooks/tnode.js';
import 'lodash/isEmpty';
import 'lodash/isFunction';
import '../../hooks/render-tnode.js';
import '../../image-viewer/base/ImageViewerUtils.js';
import '../../tooltip/index.js';
import '../../tooltip/tooltip.js';
import '../../_chunks/dep-1461d230.js';
import '../../tooltip/props.js';
import '../../popup/props.js';
import '../../popup/popup.js';
import '@popperjs/core';
import 'lodash/debounce';
import '../../utils/helper.js';
import '../../popup/container.js';
import '../../utils/event.js';
import '../../popup/utils.js';
import '../../utils/map-props.js';
import '../../tooltip/type.js';
import '../../image-viewer/utils.js';
import '../../hooks/index.js';
import '../../hooks/slots.js';
import '../../hooks/useCommonClassName.js';
import '../../hooks/useDefaultValue.js';
import '../../hooks/useDestroyOnClose.js';
import '../../hooks/useElementLazyRender.js';
import '../../_common/js/utils/observe.js';
import '../../hooks/useFormDisabled.js';
import '../../hooks/useLazyLoad.js';
import '../../hooks/useResizeObserver.js';
import '../../hooks/useVirtualScrollNew.js';
import '../../hooks/useVModel.js';
import '../../hooks/useImagePreviewUrl.js';
import '../../_common/js/log/log.js';
import '../../image-viewer/base/ImageItem.js';
import '../../image-viewer/hooks.js';
import '../../image-viewer/base/ImageViewerModal.js';
import '../../dialog/index.js';
import '../../dialog/dialog.js';
import 'lodash/throttle';
import '../../button/index.js';
import '../../button/button.js';
import '../../button/props.js';
import '../../utils/ripple.js';
import '../../button/type.js';
import '../../dialog/actions.js';
import '../../dialog/props.js';
import '../../dialog/stack.js';
import '../../_common/js/utils/getScrollbarWidth.js';
import '../../dialog/type.js';
import '../../dialog/plugin.js';
import '../../config-provider/config-provider.js';
import 'lodash/cloneDeep';
import '../../image-viewer/const.js';
import '../../image/image.js';
import 'lodash/omit';
import '../../image/props.js';
import '../../space/index.js';
import '../../space/space.js';
import '../../space/props.js';
import '../../space/type.js';
import '../../image/type.js';
import '../../image-viewer/type.js';
import '../../link/link.js';
import '../../link/props.js';
import '../../link/type.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ImageCard = defineComponent({
  name: "UploadImageCard",
  props: _objectSpread(_objectSpread({}, commonProps), {}, {
    multiple: Boolean,
    max: Number,
    disabled: Boolean,
    showUploadProgress: Boolean,
    triggerUpload: Function,
    uploadFiles: Function,
    cancelUpload: Function
  }),
  setup: function setup(props) {
    var _toRefs = toRefs(props),
      displayFiles = _toRefs.displayFiles,
      multiple = _toRefs.multiple,
      max = _toRefs.max;
    var icons = useGlobalIcon({
      AddIcon: AddIcon,
      BrowseIcon: BrowseIcon,
      DeleteIcon: DeleteIcon,
      ErrorCircleFilledIcon: ErrorCircleFilledIcon
    });
    var showTrigger = computed(function () {
      var _displayFiles$value;
      if (multiple.value) {
        return !max.value || displayFiles.value.length < max.value;
      }
      return !((_displayFiles$value = displayFiles.value) !== null && _displayFiles$value !== void 0 && _displayFiles$value[0]);
    });
    return {
      icons: icons,
      showTrigger: showTrigger
    };
  },
  methods: {
    renderMainContent: function renderMainContent(file, index) {
      var _this = this;
      var h = this.$createElement;
      var _this$icons = this.icons,
        BrowseIcon = _this$icons.BrowseIcon,
        DeleteIcon = _this$icons.DeleteIcon;
      return h("div", {
        "class": "".concat(this.classPrefix, "-upload__card-content ").concat(this.classPrefix, "-upload__card-box")
      }, [h(Image, {
        "class": "".concat(this.classPrefix, "-upload__card-image"),
        "attrs": {
          "src": file.url || file.raw,
          "error": ""
        }
      }), h("div", {
        "class": "".concat(this.classPrefix, "-upload__card-mask")
      }, [h("span", {
        "class": "".concat(this.classPrefix, "-upload__card-mask-item"),
        "on": {
          "click": function click(e) {
            return e.stopPropagation();
          }
        }
      }, [h(ImageViewer, {
        "attrs": {
          "images": this.displayFiles.map(function (t) {
            return t.url || t.raw;
          }),
          "defaultIndex": index,
          "trigger": function trigger(h, _ref) {
            var open = _ref.open;
            return h(BrowseIcon, {
              "on": {
                "click": function click(_ref2) {
                  var e = _ref2.e;
                  _this.$emit("preview", {
                    file: file,
                    index: index,
                    e: e
                  });
                  open();
                }
              }
            });
          }
        }
      })]), !this.disabled && [h("span", {
        "class": "".concat(this.classPrefix, "-upload__card-mask-item-divider")
      }), h("span", {
        "class": "".concat(this.classPrefix, "-upload__card-mask-item"),
        "on": {
          "click": function click(e) {
            return e.stopPropagation();
          }
        }
      }, [h(DeleteIcon, {
        "on": {
          "click": function click(_ref3) {
            var _this$onRemove;
            var e = _ref3.e;
            return (_this$onRemove = _this.onRemove) === null || _this$onRemove === void 0 ? void 0 : _this$onRemove.call(_this, {
              e: e,
              file: file,
              index: index
            });
          }
        }
      })])]])]);
    },
    renderProgressFile: function renderProgressFile(file, loadCard) {
      var _this$locale;
      var h = this.$createElement;
      return h("div", {
        "class": [loadCard, "".concat(this.classPrefix, "-upload__").concat(this.theme, "-").concat(file.status)]
      }, [h(Loading, {
        "attrs": {
          "loading": true,
          "size": "medium"
        }
      }), h("p", [(_this$locale = this.locale) === null || _this$locale === void 0 || (_this$locale = _this$locale.progress) === null || _this$locale === void 0 ? void 0 : _this$locale.uploadingText, this.showUploadProgress ? " ".concat(file.percent, "%") : ""])]);
    },
    renderFailFile: function renderFailFile(file, index, loadCard) {
      var _file$response,
        _this$locale2,
        _this2 = this;
      var h = this.$createElement;
      var _this$icons2 = this.icons,
        ErrorCircleFilledIcon = _this$icons2.ErrorCircleFilledIcon,
        DeleteIcon = _this$icons2.DeleteIcon;
      return h("div", {
        "class": loadCard
      }, [h(ErrorCircleFilledIcon), h("p", [((_file$response = file.response) === null || _file$response === void 0 ? void 0 : _file$response.error) || ((_this$locale2 = this.locale) === null || _this$locale2 === void 0 || (_this$locale2 = _this$locale2.progress) === null || _this$locale2 === void 0 ? void 0 : _this$locale2.failText)]), h("div", {
        "class": "".concat(this.classPrefix, "-upload__card-mask")
      }, [h("span", {
        "class": "".concat(this.classPrefix, "-upload__card-mask-item"),
        "on": {
          "click": function click(e) {
            return e.stopPropagation();
          }
        }
      }, [h(DeleteIcon, {
        "on": {
          "click": function click(_ref4) {
            var _this2$onRemove;
            var e = _ref4.e;
            return (_this2$onRemove = _this2.onRemove) === null || _this2$onRemove === void 0 ? void 0 : _this2$onRemove.call(_this2, {
              e: e,
              file: file,
              index: index
            });
          }
        }
      })])])]);
    }
  },
  render: function render() {
    var _this$displayFiles,
      _this3 = this,
      _this$locale3;
    var h = arguments[0];
    var customList = renderTNodeJSX(this, "fileListDisplay", {
      params: {
        files: this.displayFiles
      }
    });
    if (customList) return customList;
    var cardItemClasses = "".concat(this.classPrefix, "-upload__card-item ").concat(this.classPrefix, "-is-background");
    var AddIcon = this.icons.AddIcon;
    return h("div", [h("ul", {
      "class": "".concat(this.classPrefix, "-upload__card")
    }, [(_this$displayFiles = this.displayFiles) === null || _this$displayFiles === void 0 ? void 0 : _this$displayFiles.map(function (file, index) {
      var loadCard = "".concat(_this3.classPrefix, "-upload__card-container ").concat(_this3.classPrefix, "-upload__card-box");
      var fileName = _this3.abridgeName ? abridgeName.apply(void 0, [file.name].concat(_toConsumableArray(_this3.abridgeName))) : file.name;
      var fileNameClassName = "".concat(_this3.classPrefix, "-upload__card-name");
      return h("li", {
        "class": cardItemClasses,
        "key": index
      }, [file.status === "progress" && _this3.renderProgressFile(file, loadCard), file.status === "fail" && _this3.renderFailFile(file, index, loadCard), !["progress", "fail"].includes(file.status) && _this3.renderMainContent(file, index), fileName && (file.url ? h(Link, {
        "attrs": {
          "href": file.url,
          "target": "_blank",
          "hover": "color",
          "size": "small"
        },
        "class": fileNameClassName
      }, [fileName]) : h("span", {
        "class": fileNameClassName
      }, [fileName]))]);
    }), this.showTrigger && !this.disabled && h("li", {
      "class": cardItemClasses,
      "on": {
        "click": this.triggerUpload
      }
    }, [h("div", {
      "class": "".concat(this.classPrefix, "-upload__image-add ").concat(this.classPrefix, "-upload__card-container ").concat(this.classPrefix, "-upload__card-box")
    }, [h(AddIcon), h("p", {
      "class": "".concat(this.classPrefix, "-size-s")
    }, [(_this$locale3 = this.locale) === null || _this$locale3 === void 0 || (_this$locale3 = _this$locale3.triggerUploadText) === null || _this$locale3 === void 0 ? void 0 : _this$locale3.image])])])])]);
  }
});

export { ImageCard as default };
//# sourceMappingURL=image-card.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/upload/themes/image-card.js
// module id = null
// module chunks = 